import { render, staticRenderFns } from "./betLimitSettings.vue?vue&type=template&id=302c0e58&lang=pug&"
import script from "./betLimitSettings.vue?vue&type=script&lang=js&"
export * from "./betLimitSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports